import { Trans } from '@lingui/react/macro';
import { ceil } from 'lodash';

import type { TProcedure } from '@/react-query/useVisitSummaries';

interface Props {
  gapDist?: number;
  hasCrowding?: boolean;
  name: TProcedure['name'];
  summedToothSpacing?: number;
}

export const ImplantAndAlignerText = ({
  gapDist,
  hasCrowding,
  name,
  summedToothSpacing,
}: Props) => {
  switch (name) {
    case 'implant':
      return typeof gapDist === 'number' ? (
        <p className="vai-text-sm vai-text-gray-400">
          {ceil(gapDist)}
          <Trans>mm of interproximal space detected</Trans>
        </p>
      ) : null;
    case 'aligner':
      if (hasCrowding) {
        return (
          <p className="vai-text-sm vai-text-gray-400">
            <Trans>Crowding detected in this arch</Trans>
          </p>
        );
      }
      if (typeof summedToothSpacing === 'number') {
        return (
          <p className="vai-text-sm vai-text-gray-400">
            {ceil(summedToothSpacing)}
            <Trans>mm of total spacing detected in this arch</Trans>
          </p>
        );
      }
      return null;
    default:
      return null;
  }
};
